import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';

import withPermissions from '../../../../auth/utils/withPermissions';
import {
  fetchShopDiscounts,
  fetchBarberDiscounts,
} from '../actions';
import { getDiscounts } from '../selectors';
import { getRoleIdType } from '../../../../auth/selectors';
import List from '../components/List';
import fetchOnUpdate from '../../../../common/decorators/fetchOnUpdate';
import withCurrency from '../../../../common/hoc/withCurrency';

const mapStateToProps = (state) => {
  const shopOrBarber = getRoleIdType(state);
  return {
    discounts: getDiscounts(state),
    type: shopOrBarber.type,
    params: {
      id: shopOrBarber.id,
    },
    baseUrl: shopOrBarber.type === 'shop' ? '/settings/discounts' : '/barber/settings/discounts',
  };
};
const mapDispatchToProps = {
  fetchShopDiscounts,
  fetchBarberDiscounts,
};
export default compose(
  withPermissions,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    actions: {
      fetchDiscounts: props.type === 'shop' ? props.fetchShopDiscounts : props.fetchBarberDiscounts,
    },
  })),
  fetchOnUpdate(['id'], (params, actions) => actions.fetchDiscounts(params.id)),
  withCurrency
)(List);
